import React from 'react';

const AnalyticsPage = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8">
          Analytics & Insights Solutions
        </h1>
        
        <div className="prose dark:prose-invert max-w-none">
          <p className="text-xl text-gray-600 dark:text-gray-300 mb-8">
            Turn your data into actionable insights with our advanced analytics platform.
            Make informed decisions, identify trends, and optimize performance with powerful data visualization and analysis tools.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Real-time Analytics
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Monitor key metrics in real-time with interactive dashboards.
                Get instant insights into your operations and respond quickly to changing conditions.
              </p>
            </div>

            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Predictive Analytics
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Forecast trends and anticipate future outcomes using advanced machine learning models.
                Make proactive decisions based on data-driven predictions.
              </p>
            </div>

            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Custom Reporting
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Create tailored reports that match your specific needs.
                Share insights across your organization with automated report generation and distribution.
              </p>
            </div>

            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Performance Optimization
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Identify bottlenecks and opportunities for improvement.
                Optimize processes and resource allocation based on detailed performance analytics.
              </p>
            </div>
          </div>

          <div className="bg-primary-50 dark:bg-gray-800 p-8 rounded-lg mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Key Features
            </h2>
            <ul className="space-y-4 text-gray-600 dark:text-gray-300">
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary-600 dark:text-primary-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Interactive data visualization tools</span>
              </li>
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary-600 dark:text-primary-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Advanced statistical analysis capabilities</span>
              </li>
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary-600 dark:text-primary-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Customizable dashboards and reports</span>
              </li>
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary-600 dark:text-primary-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Machine learning-powered insights</span>
              </li>
            </ul>
          </div>

          <div className="text-center">
            <a 
              href="/contact" 
              className="inline-block bg-primary-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-primary-700 transition-colors"
            >
              Request a Demo
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsPage; 